import "./Card.css";

function Card({
    title,
    action,
    children,
    className = "",
}) {

    return (

        <div className={`admin-card ${className}`}>

            {(title || action) && (

                <div className="admin-card-header">

                    {title && <h2>{title}</h2>}

                    {action && (
                        <div className="admin-card-action">
                            {action}
                        </div>
                    )}

                </div>

            )}

            <div className="admin-card-body">

                {children}

            </div>

        </div>

    );

}

export default Card;